<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="collapsable-header">
          <div class="bold mb">Öffentliches Profil</div>
          <div class="">Bestimme, wie dein Profil für andere gezeigt wird</div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="settings-collapsable-inner">
          <div class="settings-collapsable-left">
            <div class="input-text-wrapper no-m">
              <label for="username" class="input-label">Nutzername</label>

              <input
                id="username"
                type="username"
                class="input-text input-text-border"
                name="username"
                required
                autocomplete="new-password"
                v-model="username"
              />
            </div>

            <div class="avatar-change-wrapper">
              <label for="username" class="input-label">Avatar</label>
              <img
                class="avatar-preview"
                width="200"
                height="200"
                :src="avatarPath"
              />

              <label for="imageupload" class="image-upload">
                Avatar hochladen
              </label>
              <input
                id="imageupload"
                type="file"
                @change="onFileChange"
                multiple
              />
            </div>
          </div>

          <div class="settings-collapsable-right">
            <div class="err-succ-messages">
              <div class="success-message">
                {{ successMessage }}
              </div>
              <div class="error-message">
                {{ errorMessage }}
              </div>
            </div>
            <button @click.prevent="saveChanges()" class="btn btn-blue">
              Änderungen speichern
            </button>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["currentName", "currentAvatar"],
  data() {
    return {
      username: this.currentName,
      avatar: this.currentAvatar,
      newImage: null,
      newImagePath: null,
      errorMessage: null,
      successMessage: null,
    };
  },
  watch: {},
  methods: {
    saveChanges() {
      let formData = new FormData();

      formData.append("name", this.username);
      if (this.newImage) {
        formData.append("file", this.newImage);
      }

      axios
        .post("/profile", formData)
        .then((res) => {
          this.successMessage =
            "Dein Profil wurde erfolgreich geändert.";
        })
        .catch((error) => {
          if (error.response.status === 422) {
            for (const [key, value] of Object.entries(
              error.response.data.errors
            )) {
              this.errorMessages.push(value[0]);
            }
          }
          console.log(error.response.data);
        });
    },
    onFileChange(e) {
      this.newImage = e.target.files[0];
      this.newImagePath = URL.createObjectURL(this.newImage);
    },
  },
  mounted() {},
  created() {},
  computed: {
    avatarPath() {
      let path;
      if (this.newImage) {
        path = this.newImagePath;
      } else {
        path = this.avatar;
      }
      return path;
    },
  },
};
</script>

<style>
</style>
